import { Navigation, Mousewheel } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { customerRelationships } from './common/Helper'
import CustomerSliderHeading from './custom-ui/CustomerSliderHeading'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'

// import required modules

const CustomerPeople = () => {
  return (
    <>
      {customerRelationships.map((value, index) => {
        const prevButtonClass = `.people-swiper-button-prev-${index}`
        const nextButtonClass = `.people-swiper-button-next-${index}`
        return (
          <div
            key={index}
            className="overflow-x-hidden pt-10 sm:pt-[72px]"
          >
            <CustomerSliderHeading
              icon={value.icon}
              heading={value.heading}
              subheading={value.subheading}
              index={index}
            />
            <div className="customers-slider relative mx-auto max-w-[1600px]  ps-6 sm:ml-[calc((100%-600px)/2)] md:ml-[calc((100%-768px)/2)] lg:ml-[calc((100%-1024px)/2)] xl:ml-[calc((100%-1200px)/2)] xl:px-0">
              <Swiper
                slidesPerView={1.1}
                spaceBetween={12}
                navigation={{
                  prevEl: prevButtonClass,
                  nextEl: nextButtonClass,
                }}
                speed={700}
                mousewheel={{
                  forceToAxis: true,
                }}
                loop={false}
                breakpoints={{
                  1400: {
                    slidesPerView: 3.3,
                  },
                  1280: {
                    slidesPerView: 3,
                  },
                  1024: {
                    slidesPerView: 2.5,
                  },
                  768: {
                    slidesPerView: 2,
                  },
                  550: {
                    slidesPerView: 1.5,
                  },
                }}
                modules={[Navigation, Mousewheel]}
                className="mySwiper !py-6"
              >
                {value.cards.map((value, index) => {
                  return (
                    <SwiperSlide
                      key={index}
                      className="overflow-hidden shadow-card-shadow"
                    >
                      <div className="group relative min-h-[450px] rounded-md border border-black border-opacity-[6%] bg-night-black p-6 sm:min-h-[500px]">
                        <h3 className="relative z-20 text-xl font-semibold leading-[115%] tracking-2xl text-white sm:text-2xl sm:tracking-3xl">
                          {value.heading}
                        </h3>
                        <p className="font-semiblod relative z-20 pt-2 text-sm tracking-sm text-white sm:text-base sm:tracking-md">
                          {value.description}
                        </p>
                        <img
                          className={`absolute top-[190px] z-0  h-[370px] w-[449px] object-contain object-center duration-300 group-hover:left-6 group-hover:rotate-0 lg:top-[180px] ${value.imageStyle}`}
                          src={value.image}
                          alt="intellibit"
                        />
                      </div>
                    </SwiperSlide>
                  )
                })}
              </Swiper>
            </div>
          </div>
        )
      })}
    </>
  )
}

export default CustomerPeople
